import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-04234100")
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({lobbyWindow:true})
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LobbyAccount = _resolveComponent("LobbyAccount")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$store.state.GameView.lobby.players)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.GameView.lobby.players, (user, index) => {
            return (_openBlock(), _createBlock(_component_LobbyAccount, {
              small: _ctx.small,
              player: user,
              index: index,
              key: `lobby_player_${index}`
            }, null, 8, ["small", "player", "index"]))
          }), 128)),
          (_ctx.$store.state.GameView.fakiePresent)
            ? (_openBlock(), _createBlock(_component_LobbyAccount, {
                small: _ctx.small,
                player: { 
        "avatar": "john", 
        "developer": false, 
        "email": "fakie@gmail.com", 
        "host": false, 
        "id": "fakie", 
        "joined": new Date().getTime(), 
        "lastPing": new Date().getTime(), 
        "name": "Fakie", 
        "picture": "", 
        "unset": false },
                key: `lobby_player_fakie`
              }, null, 8, ["small", "player"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}